export default __webpack_public_path__ + "static/media/donut-gold.205f0c64.png";